import React from 'react'
import { ProductSummary } from '../../../features/package/packageInterface';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { clientSpecialPackageDetailTheadData } from '../../../data/admin-data';

interface ClientUpdatePackageProductsTBodyProps {
    prod: ProductSummary[] | null
    isLoading: boolean
    isError: boolean
    errorMessage: string;
    isEmpty: boolean;
    isEditing: boolean;
    handleRemoveNewProduct: (id: number) => void;
    handleToggleProduct: (id: number) => void;
}

export default function ClientUpdatePackageProductsTBody({ handleToggleProduct, handleRemoveNewProduct, isEditing, prod, isLoading, isEmpty, errorMessage, isError }: ClientUpdatePackageProductsTBodyProps) {
    return (
        <tbody className='w-full'>
            {isLoading ? (
                <tr>
                    <td colSpan={clientSpecialPackageDetailTheadData.length}  className='h-auto text-center'> 
                        <div className="flex space-x-1 justify-center items-center w-full h-full">
                            <Loading message="Loading product..." />
                        </div>
                    </td>
                </tr>
            ) : isError ? (
                <tr>
                    <td colSpan={clientSpecialPackageDetailTheadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <ErrorMessage message={errorMessage} textStyle={``}/>
                        </div>
                    </td>
                </tr>
            ) : isEmpty ? (
                <tr>
                    <td colSpan={clientSpecialPackageDetailTheadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <p className='text-gray-500 text-xs'>No result found.</p>
                        </div>
                    </td>
                </tr>
            ) : (
                prod?.map((prod, index) => {
                    const addons = prod.addons ?? [];
                    const isActive = prod.isActive ? "Yes" : "No";
                    return (
                        <tr 
                            key={prod.productID} 
                            className={`hover:bg-gray-100 text-xs cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                        >
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                {/* <div className="truncate font-normal">
                                    {prod.productName}
                                </div> */}
                                <div className="col-span-3 font-semibold flex items-center gap-2 min-w-0">
                                    {isEditing && (
                                        prod.type === "new" ? (
                                            <button
                                                onClick={() => handleRemoveNewProduct(prod.productID)}
                                                className="text-red-500 hover:text-red-700 transition-colors"
                                                title="Remove product"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="w-4 h-4"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                    strokeWidth={2}
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M6 7h12M9 7V5h6v2m-7 0v12m4-12v12m4-12v12M5 7l1 13a1 1 0 001 1h10a1 1 0 001-1l1-13"
                                                    />
                                                </svg>
                                            </button>
                                        ) : (
                                            <input
                                                type="checkbox"
                                                checked={prod.isActive}
                                                onChange={() => handleToggleProduct(prod.productID)}
                                            />
                                        )
                                    )}
                                    <span className="truncate">{prod.productName}</span>
                                    {prod.type === "new" && (
                                        <span className="px-1.5 py-0.5 rounded bg-green-600 text-white text-[9px] font-semibold uppercase">
                                            New
                                        </span>
                                    )}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {prod.typeName}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {prod.categoryName}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {isActive}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {prod.price}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {addons.map((add) => (
                                        <div key={add.addonID}>{add.addonName}</div>
                                    ))}
                                </div>
                            </th>
                        </tr>
                    )
                })
            )}
        </tbody>
    )
}
